import { render } from "./NewContractPage.vue?vue&type=template&id=77b64515"
import script from "./NewContractPage.vue?vue&type=script&lang=js"
export * from "./NewContractPage.vue?vue&type=script&lang=js"

import "./NewContractPage.vue?vue&type=style&index=0&id=77b64515&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__